import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "rounded shadow bg-white pb-3" }
const _hoisted_2 = { class: "d-flex justify-content-between px-4 py-3 mt-5" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "form-select me-3" }
const _hoisted_5 = { class: "table main-table" }
const _hoisted_6 = { class: "text-primary fw-bold" }
const _hoisted_7 = { class: "text-muted" }
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JMEntriesItem = _resolveComponent("JMEntriesItem")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_JMTablePaginate = _resolveComponent("JMTablePaginate")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[5] || (_cache[5] = _createElementVNode("h2", null, "Store", -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "me-3" }, "Entries", -1)),
          _createElementVNode("select", _hoisted_4, [
            _createVNode(_component_JMEntriesItem)
          ]),
          _createVNode(_component_router_link, {
            class: "btn btn-primary me-3",
            to: "/store/form"
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createElementVNode("div", { class: "text-nowrap text-white" }, "Add Record", -1)
            ])),
            _: 1
          })
        ])
      ]),
      _createElementVNode("table", _hoisted_5, [
        _cache[4] || (_cache[4] = _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, [
              _createElementVNode("span", null, "#")
            ]),
            _createElementVNode("th", null, [
              _createElementVNode("span", null, "Description"),
              _createElementVNode("i", { class: "fad fa-sort-up ms-2" })
            ]),
            _createElementVNode("th", null, [
              _createElementVNode("span", null, "Unit"),
              _createElementVNode("i", { class: "fad fa-sort-up ms-2" })
            ]),
            _createElementVNode("th")
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.docs, (item, index) => {
            return (_openBlock(), _createElementBlock("tr", null, [
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_6, "#" + _toDisplayString(((_ctx.page-1)*_ctx.show)+(index+1)), 1)
              ]),
              _createElementVNode("td", null, _toDisplayString(item.name), 1),
              _createElementVNode("td", null, _toDisplayString(item.unit), 1),
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_7, [
                  (_ctx.store.state.accessLevel>=5)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: `/store/edit/${item._id}`
                      }, {
                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                          _createElementVNode("i", { class: "class fal fa-pencil text-warning" }, null, -1)
                        ])),
                        _: 2
                      }, 1032, ["to"]))
                    : _createCommentVNode("", true),
                  (_ctx.store.state.accessLevel>=5)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 1,
                        class: "class fal fa-trash text-danger ms-3",
                        onClick: ($event: any) => (_ctx.deleteItem(item._id))
                      }, null, 8, _hoisted_8))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          }), 256))
        ])
      ]),
      _createVNode(_component_JMTablePaginate, {
        page: _ctx.page,
        pages: _ctx.pages,
        show: _ctx.show,
        total: _ctx.total,
        onChange: _cache[0] || (_cache[0] = ($event: any) => {_ctx.page=$event; _ctx.fetchData()})
      }, null, 8, ["page", "pages", "show", "total"])
    ])
  ], 64))
}